<template>
  <div
    v-loading="eventIsBeingCreated"
    element-loading-text="Creating your event.."
    class="p-20 mobile-l:p-25 tablet:p-35"
  >
    <EventEditForm
      class="w-full tablet:max-w-500"
      :is-loading.sync="eventIsBeingCreated"
      @submit-successful="onSubmitSuccessful($event)"
      @submit-failed="onSubmitFailed"
    />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { showErrorNotification, showSuccessNotification } from '@/utils/notification';
import EventEditForm from '@/components/event/EventEditForm';

export default {
  components: {
    EventEditForm,
  },
  data: () => ({
    eventIsBeingCreated: false,
  }),
  methods: {
    ...mapActions('navigation', {
      updateCurrentNavigationTitleSuffix: 'updateCurrentNavigationTitleSuffix',
    }),
    onSubmitSuccessful(eventId) {
      this.$router.push({ name: 'EventDetails', params: { eventID: eventId } });
      showSuccessNotification('Added the Event successfully.');
    },
    onSubmitFailed(error) {
      showErrorNotification(error.message);
    },
  },
  beforeDestroy() {
    this.updateCurrentNavigationTitleSuffix('');
  },
};
</script>

<style scoped>
</style>
